import { WarningIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Error = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <WarningIcon {...rest} size={Sizes[size]} color={fill} />;
};

Error.displayName = 'Error';
